import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import { Checkbox, FormControlLabel } from "@mui/material";
export default function CustomSearchTrackingMenu({ isMenuOpen, alldata, handleCheckboxChange, checked, handleSearch, isSearch, searchText, setSearchText }) {

    const handleAddNewKeyword = () => {
        if (searchText && !checked.includes(searchText)) {
            handleCheckboxChange({ target: { checked: true } }, searchText);
        }
        setSearchText("")
    };

    const isNewKeyword = searchText && !alldata?.some(item =>
        item.toLowerCase() === searchText.toLowerCase()
    );
    return (
        <>
            {
                isMenuOpen &&
                <div className="crie-filter-inner-container-drop-track">
                    <div>
                        {
                            isSearch &&
                            <div className="crie_input_cont">
                                <input type="text" placeholder="Type to search" className="crie_input" onChange={(e) => handleSearch(e?.target?.value)} />
                            </div>
                        }
                        {isNewKeyword && (
                            <div
                                className="location_filter_leads_crie"
                                onClick={handleAddNewKeyword}
                                style={{ cursor: 'pointer', padding: '8px', backgroundColor: '#f9f9f9' }}
                            >
                                ➕ Add "<strong>{searchText}</strong>" to selection
                            </div>
                        )}
                        {
                            alldata?.map((item, index) => (
                                <div className="location_filter_leads_crie">
                                    <div className="AI-leader-checkbox-and-data-list">
                                        <div className="checkbox-select-data">
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={checked.includes(item)}
                                                        value={item}
                                                        onChange={(event) =>
                                                            handleCheckboxChange(event, item)
                                                        }
                                                        className="checkbox-green location_filter_checkbox"
                                                        color="success"
                                                    />
                                                }
                                                label={<MenuItem className="menuitems">{item}</MenuItem>}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))
                        }

                    </div>
                </div>
            }
        </>
    );
}